<template>
  <div class="selfOperation">
    <!-- RDMS续费 自助维护 -->
    <!-- <div class="info"> -->
    <el-row class="topMessage">
      <el-col class="">
        <span>客户名称：{{$store.state.user.defaultCompanyName}}</span>
      </el-col>
    </el-row>
    <!-- </div> -->
    <el-table :data="dataList"
              border
              v-loading="loading"
              style="width: 100%">
      <el-table-column align="center"
                       header-align="center"
                       label="序号"
                       type="index"
                       width="50"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="gateway"
                       label="网关编号"></el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="endAt"
                       label="网关状态">
        <template slot-scope="scope">
          <span v-if="scope.row.active === true">激活</span>
          <span v-else>未激活</span>
        </template>
      </el-table-column>
      <el-table-column align="center"
                       header-align="center"
                       prop="endAt"
                       label="套餐到期日期">
        <template slot-scope="scope">
          {{ timeFormate(scope.row.endAt) }}
        </template>
      </el-table-column>
      <el-table-column prop=""
                       label="套餐剩余时长"
                       align="center"
                       :formatter="formatEndDay">
      </el-table-column>
      <el-table-column label="操作"
                       align="center"
                       width="180"
                       header-align="center">
        <template slot-scope="scope">
          <el-button type="text"
                     size="mini"
                     @click="buyOpenHandle(scope.row)">套餐购买</el-button>
          <el-button type="text"
                     size="mini"
                     @click="usedOpenHandle(scope.row)">预充套餐使用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 自助运维服务商品列表 -->
    <el-dialog :visible.sync="visibleGoods" width="70%">
      <el-table :data="commodityListData" border style="width: 100%">
        <el-table-column align="center" header-align="center" label="序号" type="index" width="50"></el-table-column>
        <el-table-column align="center" header-align="center" prop="title" label="商品名称"></el-table-column>
        <el-table-column align="center" header-align="center" prop="skuCode" label="商品编码"></el-table-column>
        <el-table-column align="center" header-align="center" prop="sellingPrice" label="商品价格"></el-table-column>
        <el-table-column align="center" header-align="center" prop="model" label="商品属性">
        </el-table-column>
        <el-table-column align="left" width="300" header-align="center" prop="summary" :show-overflow-tooltip="true" label="商品描述">
          <template slot-scope="scope">
            <div class="tooltip-div" v-if="scope.row.summary" v-html="decodeURIComponent(scope.row.summary)"></div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" header-align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="detailHandle(scope.row)"> 查看详细 </el-button>
            <el-button type="text" size="mini" @click="buyNumHandle(scope.row)"> 购买 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        append-to-body
        :visible.sync="buyVisible"
        width="500px">
        <el-form :model="buyInfo" :rules="rules" ref="buyForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="购买数量" prop="buyCount">
            <el-input-number v-model="buyInfo.buyCount" :min="buyInfo.min"></el-input-number>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="buyHandle()">立即购买</el-button>
            <el-button @click="handleReset()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <!-- 预充套餐 -->
    <el-dialog :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="packageVisible"
               width="70%">
      <el-tabs type="border-card" v-model="tabActive" @tab-click="handleClickTabs">
        <el-tab-pane label="可用预充套餐" name="getPackageList">
          <el-table :data="packageList"
                    border
                    v-loading="packageLoading"
                    style="width: 100%">
            <el-table-column align="center"
                             header-align="center"
                             label="序号"
                             type="index"
                             width="50"></el-table-column>
            <el-table-column align="center"
                             header-align="center"
                             prop="packageCode"
                             label="预充套餐编号"></el-table-column>
            <el-table-column align="center"
                             header-align="center"
                             prop="code"
                             label="预充套餐标识"></el-table-column>
            <el-table-column align="center"
                             header-align="center"
                             prop="name"
                             label="预充套餐名称"></el-table-column>
            <el-table-column align="center"
                             header-align="center"
                             prop="createdAt"
                             label="预充套餐创建时间">
              <template slot-scope="scope">
                {{ timeFormate(scope.row.createdAt) }}
              </template>
            </el-table-column>
            <el-table-column align="center"
                             header-align="center"
                             prop="value"
                             label="预充套餐时长（月）">
            </el-table-column>
            <el-table-column label="操作"
                             align="center"
                             header-align="center">
              <template slot-scope="scope">
                <el-button type="text"
                           size="mini"
                           @click="usedHandle(scope.row)">使用</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="预充套餐使用记录" name="getHistory">
          <el-table :data="packageHistorayList"
                    border
                    style="width: 100%">
            <el-table-column align="center"
                             header-align="center"
                             label="序号"
                             type="index"
                             width="50"></el-table-column>
            <el-table-column align="center"
                              header-align="center"
                              prop="gateway"
                              label="网关编号"></el-table-column>
            <el-table-column align="center"
                             header-align="center"
                             prop="activePackageCode"
                             label="预充套餐编号"></el-table-column>
            <el-table-column align="center"
                             header-align="center"
                             prop="code"
                             label="预充套餐标识"></el-table-column>
            <el-table-column align="center"
                             header-align="center"
                             prop="activePackageName"
                             label="预充套餐名称"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import { fomatDate, openOther } from '@/utils'
import { getAccessToken } from '@/utils/userInfo'
export default {
  name: 'selfOperation', // 自助运维
  data () {
    return {
      loading: false,
      packageLoading: false,
      dataList: [],
      packageList: [], // 未使用流量包
      permissions: false, // 权限
      gatewayChoosed: null, // 选中的网管
      visibleGoods: false,
      commodityListData: [], // 自助运维商品列表
      buyVisible: false,
      buyInfo: {
        goodSpuId: '',
        goodSkuId: '',
        buyCount: 1,
        min: 1
      },
      // 预充套餐
      packageVisible: false,
      tabActive: 'getPackageList',
      packageHistorayList: []
    }
  },
  computed: {
    rules () {
      return {
        buyCount: [
          { required: true, type: 'number', message: '购买数量不能为空' },
          { min: 1, max: 10, type: 'number', trigger: 'change', message: '购买数量只能输入1-10' }
          // { type: 'number', message: '购买数量必须为数字值' }
        ]
      }
    }
  },
  mounted () {
    this.getPackageList()
    this.getDataList()
  },
  methods: {
    // 获取未使用流量包及流量包使用权限
    getPackageList () {
      this.packageList = []
      this.permissions = false
      this.$request.get(`/front/consumer/fictitiousorder/unusedPackage?customerCode=${this.$store.state.user.nameSpace}`)
        .then(data => {
          this.packageList = data.packages || []
          this.permissions = data.permission
        })
    },
    // 获取网关列表
    getDataList () {
      this.loading = true
      this.$request.get(`/front/consumer/fictitiousorder/gateWayStatus?customerCode=${this.$store.state.user.nameSpace}`)
        .then(res => {
          this.dataList = res || []
        })
        .catch(() => {
          this.dataList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 剩余时长
    formatEndDay (row) {
      if (row.endAt && row.endAt !== '') {
        let nowTime = (new Date()).getTime() / 1000 // 当前时间
        let time = parseInt(row.endAt) - nowTime // 需要转换的时间秒
        // let time1 = 0 // 分
        // let time2 = 0 // 小时
        let time3 = 0 // 天
        if (time > 60) {
          // time1 = parseInt(time % 60)
          // time2 = parseInt(time / 60 % 60)
          time3 = parseInt(time / 60 / 60 / 24)
        }
        let result = ''
        if (time3 > 0) {
          result += time3 + '天'
        }
        // if (time2 > 0) {
        //   result += time2 + '时'
        // }
        // if (time1 > 0) {
        //   result += time1 + '分'
        // }
        return result || '0天'
      } else {
        return 0
      }
    },
    // 时间格式化
    timeFormate (time) {
      if (time) {
        let data = new Date(time * 1000)
        return fomatDate(data, 'yyyy-MM-dd')
      } else {
        return time
      }
    },
    // 套餐购买
    buyOpenHandle (row) {
      this.gatewayChoosed = row
      this.commodityListData = []
      if (this.packageList && this.packageList.length > 0) {
        if (this.permissions) {
          this.$confirm(`您所在的企业有未使用的预充套餐 ，你可以使用预充套餐对网关进行重置，是否仍要购买充值套餐?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.getGoodsList()
            this.visibleGoods = true
          })
        } else {
          this.$confirm(`您所在的企业有未使用的预充套餐，可联系对应人员使用预充套餐充值，是否仍要购买充值套餐?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.getGoodsList()
            this.visibleGoods = true
          })
        }
      } else {
        this.getGoodsList()
        this.visibleGoods = true
      }
    },
    // 查找自助运维商品列表接口
    getGoodsList () {
      this.loading = true
      this.$request.get(`/front/consumer/fictitiousorder/selectSelfRdmsCommodityList?resourceCode=RDMS`)
        .then(res => {
          this.commodityListData = res || []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 跳转商品详情
    detailHandle (row) {
      openOther(`goodDetail?spuId=${row.spuId}&skuId=${row.skuId || ''}`)
    },
    // 选择商品数量
    buyNumHandle (row) {
      this.buyInfo.goodSpuId = row.spuId
      this.buyInfo.goodSkuId = row.skuId
      this.buyInfo.buyCount = 1
      this.buyVisible = true
    },
    // 购买
    buyHandle () {
      this.$refs['buyForm'].validate((valid) => {
        if (valid) {
          if (getAccessToken()) {
            if (this.$store.state.user.defaultCompanyId) {
              this.$router.push({
                name: 'createRdmsOrder',
                query: {
                  goodsNum: this.buyInfo.buyCount,
                  goodSpuId: this.buyInfo.goodSpuId,
                  goodSkuId: this.buyInfo.goodSkuId,
                  gatewayId: this.gatewayChoosed.gateway,
                  active: this.gatewayChoosed.active ? 1 : 0,
                  endAt: this.gatewayChoosed.endAt,
                  // enterprise: this.rdmsInfo.enterprise,
                  orderSource: '80'// 商品来源：60，在线；80，自助
                }
              })
            } else {
              this.$message.error('您还没有绑定公司,请联系贵公司的管理员')
            }
          } else {
            this.$router.push({ name: 'login' })
          }
        }
      })
    },
    // 取消购买
    handleReset () {
      this.buyVisible = false
      this.buyInfo.goodSpuId = ''
      this.buyInfo.goodSkuId = ''
      this.buyInfo.buyCount = 1
      this.buyInfo.min = 1
    },
    // -----end----start-----预充套餐试用
    usedOpenHandle (row) {
      this.getPackageList()
      this.tabActive = 'getPackageList'
      this.gatewayChoosed = row
      this.packageLoading = false
      this.packageVisible = true
    },
    handleClickTabs (tab) {
      this[tab.name]()
    },
    // 使用预充套餐
    usedHandle (row) {
      if (this.packageLoading) {
        return false
      }
      this.packageLoading = true
      this.$http.post(`/front/consumer/fictitiousorder/durationPrivilege`, {
        code: row.packageCode,
        gateway: this.gatewayChoosed.gateway,
        startAt: this.gatewayChoosed.endAt,
        endAt: 0,
        activePackage: true,
        activePackageCode: row.packageCode,
        comment: '',
        monthsToAdd: row.value,
        active: this.gatewayChoosed.active
      })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            this.$message.error(res.message)
            return false
          }
          this.getDataList()
          this.$message.success(res.message)
          this.packageVisible = false
        })
        .finally(() => {
          this.packageLoading = false
        })
    },
    getHistory () {
      this.packageHistorayList = []
      this.$request.get(`/front/consumer/fictitiousorder/rdmsOrderOpterationList/${this.$store.state.user.nameSpace}`)
        .then(data => {
          this.packageHistorayList = data || []
        })
    }
  }
}
</script>
<style lang='scss' scoped>
.selfOperation{}
</style>
